// Nap san pham cua tab khi nguoi dung bam sang tab do, thay vi render san ca 6 tab.
// Panel chua nap mang data-ajax-url tro toi Section Rendering API cua collection.
(function () {
  'use strict';

  var loading = new WeakSet();

  function panelFor(button) {
    var root = button.closest('tabs-component');
    if (!root) return null;
    var id = button.dataset.id;
    if (!id) return null;
    return root.querySelector('.tab-detail[data-id="' + id + '"]');
  }

  function markDone(list) {
    delete list.dataset.ajaxUrl;
    list.removeAttribute('aria-busy');
    list.classList.remove('is-loading');
  }

  function load(list) {
    var url = list.dataset.ajaxUrl;
    if (!url || loading.has(list)) return;

    loading.add(list);
    list.setAttribute('aria-busy', 'true');
    list.classList.add('is-loading');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.ajax-cards > li');
        if (!items.length) throw new Error('khong co san pham');

        var limit = parseInt(list.dataset.limit, 10) || items.length;
        var frag = document.createDocumentFragment();
        for (var i = 0; i < items.length && i < limit; i++) {
          frag.appendChild(document.importNode(items[i], true));
        }
        list.innerHTML = '';
        list.appendChild(frag);
        markDone(list);
      })
      .catch(function (err) {
        // Nap that bai: tra lai link collection de khach van di tiep duoc.
        var href = list.dataset.fallbackUrl;
        list.innerHTML = href
          ? '<li class="ajax-cards__error"><a href="' + href + '">' + (list.dataset.fallbackText || 'View collection') + '</a></li>'
          : '';
        markDone(list);
        if (window.console) console.warn('[tabs-ajax]', err.message, url);
      })
      .finally(function () {
        loading.delete(list);
      });
  }

  function onActivate(button) {
    var panel = panelFor(button);
    if (!panel) return;
    var list = panel.querySelector('[data-ajax-url]');
    if (list) load(list);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.tab-heading');
    if (button) onActivate(button);
  });

  // Nap truoc khi nguoi dung mo i chuot / cham vao tab, de bam la co ngay.
  ['pointerenter', 'touchstart'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var button = event.target.closest && event.target.closest('.tab-heading');
        if (button) onActivate(button);
      },
      { capture: true, passive: true }
    );
  });
})();
